import { Flex } from '@/components/atoms/Grid'
import { Capitalized, Tiny2 } from '@/components/atoms/typography'
import CheckBox from '@/components/molecules/checkBox'
import { CampaignDesignation, CampaignType } from '@/network/graphql.g'
import useTranslation from 'next-translate/useTranslation'
import styled from 'styled-components'
import { FC } from 'react'

export const TypeLabelMap: Record<CampaignType, string> = {
  [CampaignType.News]: 'Campaign.CampaignType.news',
  [CampaignType.Inspiration]: 'Campaign.CampaignType.inspiration',
  [CampaignType.Sale]: 'Campaign.CampaignType.sale'
}

export const DesignationLabelMap: Record<CampaignDesignation, string> = {
  [CampaignDesignation.Men]: 'Campaign.CampaignDesignation.men',
  [CampaignDesignation.Women]: 'Campaign.CampaignDesignation.women',
  [CampaignDesignation.MenWomen]: 'Campaign.CampaignDesignation.menWomen',
  [CampaignDesignation.Kids]: 'Campaign.CampaignDesignation.kids'
}

type CampaignFilterProps = {
  title: string
  items: Record<string, number>
  data: Record<string, boolean>
  labelMap: Record<string, string>
  onCheckboxClick: (item: string) => void
}

const CampaignFilter: FC<CampaignFilterProps> = ({
  title,
  items,
  data,
  labelMap,
  onCheckboxClick
}) => {
  const { t } = useTranslation('common')

  return (
    Object.keys(items).length > 0 && (
      <Flex
        alignItems={{
          desktop: 'center',
          tablet: 'center',
          mobile: 'flex-start'
        }}
      >
        <StyledCapitalized>{title}</StyledCapitalized>
        <Flex
          alignItems="center"
          height={{ desktop: 53, tablet: 46, mobile: 'auto' }}
          flexWrap="wrap"
        >
          {Object.keys(items).map((item) => (
            <CheckBox
              key={item}
              ml={3}
              size={20}
              isChecked={data[item]}
              onCheckboxClick={() => onCheckboxClick(item)}
            >
              <Tiny2>{t(labelMap[item], { count: items[item] })}</Tiny2>
            </CheckBox>
          ))}
        </Flex>
      </Flex>
    )
  )
}

export default CampaignFilter

const StyledCapitalized = styled(Capitalized)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.accent};
`
